import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import * as api from '../../api';
import { COUNTRY_COURSE_TYPE } from '../../constants';

export function* getYearGroups() {
    const payload = yield call(api.getYearGroups);
    if (payload.status === 200) {
        yield put(actions.getYearGroupsSuccess(payload));
    } else {
        yield put(actions.getYearGroupsFailure());
    }
}

export function* getYearGroupSaga() {
    yield takeLatest(actions.GET_YEAR_GROUPS_REQUEST, getYearGroups);
}

export function* getLicenceCapSummary({ productId }) {
    const payload = yield call(api.getLicenceSummaryByProduct, productId);
    if (payload.status === 200) {
        yield put(actions.getLicenceCapSummarySuccess(payload));
    } else {
        yield put(actions.getLicenceCapSummaryFailure());
    }
}

export function* getLicenceCapSummarySaga() {
    yield takeLatest(actions.GET_LICENCE_CAP_SUMMARY_REQUEST, getLicenceCapSummary);
}

export function* getCourseCountries({ selectedProductId }) {
    const countriesRequest = { ProductId: selectedProductId };
    const response = yield call(api.getCourseCountries, countriesRequest);
    if (response.status === 200) {
        yield put(actions.getCourseCountriesSuccess(response.data));
    } else {
        yield put(actions.getCourseCountriesFailure());
    }
}

export function* getCourseCountriesSaga() {
    yield takeLatest(actions.GET_COUNTRIES_REQUEST, getCourseCountries);
}

export function* getUpfCourseCountries({ selectedProductId, countryCourseType = COUNTRY_COURSE_TYPE.UPF }) {
    const countriesRequest = { ProductId: selectedProductId, countryCourseType };
    const response = yield call(api.getUpfCourseCountries, countriesRequest);
    if (response.status === 200) {
        yield put(actions.getUpfCourseCountriesSuccess(response.data));
    } else {
        yield put(actions.getUpfCourseCountriesFailure());
    }
}

export function* getUpfCourseCountriesSaga() {
    yield takeLatest(actions.GET_UPF_COUNTRIES_REQUEST, getUpfCourseCountries);
}




// WEBPACK FOOTER //
// ./app/containers/school-roll/saga.js